/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRightTail = createReactComponent("outline", "arrow-right-tail", "IconArrowRightTail", [["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-0" }], ["path", { "d": "M3 15l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M6 12l15 0", "key": "svg-2" }]]);

export { IconArrowRightTail as default };
//# sourceMappingURL=IconArrowRightTail.mjs.map
